import { AppConfig } from '@/constants/AppConfig';
import { Routes } from '@/constants/Routes';

const getOrigin = (shortUrlName: string) => {
  if (AppConfig.env.local) { return window.location.origin; }
  return `https://${shortUrlName}.${AppConfig.shortUrlDomain}`;
};

export const getCustomerDashboardUrl = (
  shortUrlName: string,
  accessToken: string,
  suffix = '',
) => {
  const path = Routes.CUSTOMER_DASHBOARD_ALT.replace(':accessToken', accessToken);
  return `${getOrigin(shortUrlName)}/#${path}${suffix}`;
};
